var map = {
	"./1.png": "28cb",
	"./2.png": "d3a0",
	"./3.png": "54f1",
	"./4.png": "7c3b",
	"./5.png": "6039",
	"./6.png": "7719",
	"./7.png": "e7b8",
	"./8.png": "0d75"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "55f5";